module.exports = __webpack_public_path__ + "img/googlePlayBg.de09e227.png";